/* =====================================================================
   9/23/26 — "CHOOSE OPTIONS" POP-UP FOR PRODUCTS WITH A RESISTORS OPTION
   (3157 / 7443 LumX-PRO Amber, Switchbacks, Red Brake / Running — and any
   product given a "Resistors" option later).

   Product page: the theme's "Please Select" dropdown, the yellow resistor
   note and the "Please Make a Selection Above" / Buy with Shop buttons are
   hidden (CSS in snippets/cdx-vehicle-fit.liquid). In their place: one black
   "Add to cart" button that opens the pop-up (9/28/26: was "Choose options").

   Collection pages / product grids: the card's button opens
   the same pop-up instead of the old inline dropdown (Resistors products only;
   other products keep the old behaviour).

   9/28/26 — SUGGESTION "ADD" BUTTONS NEVER GUESS THE VERSION ANY MORE.
   The cart drawer "Also guaranteed to fit" cards (+ Add) and the product page
   "Also guaranteed to fit your vehicle" row (Add to cart) used to add the FIRST
   version of a product, e.g. the 1997-2008 F150 reverse kit for a 2016 F150,
   or Low Beam only for a headlight package. Now:
     - one version (or only one version fits the shopper's year) -> added straight away
     - several versions -> this same pop-up opens, with the version that fits the
       shopper's year already ticked and tagged "Fits your 2016".
   The resistor warning only shows for products that have a resistors choice.

   9/28/26 — EVERY PRODUCT WITH A CHOICE NOW WORKS THIS WAY, not just Resistors:
   headlight / fog packages ("package"), year versions (F150 reverse kit, interior
   kits), sunroof option, etc. Product page: "Please Select" dropdown and the
   "Please Make a Selection Above" / Buy with Shop buttons are hidden, one
   "Add to cart" button opens the pop-up. Collection cards open the same pop-up.
   If the shopper's saved vehicle year matches exactly one version, it is ticked.
   Gift cards keep the theme's own form (they need the recipient fields).

   The pop-up matches the "Everything for your vehicle" page. Prices / stock are
   always live (the page's own variant data, /products/<handle>.js, or the live
   product feed templates/search.cdxpf.liquid).
   ===================================================================== */
(function () {
  if (window.__cdxResistorOptions) return;
  window.__cdxResistorOptions = true;

  var WARN = 'Resistors prevent hyper-flash on brake lights and blinkers. Most vehicles require resistors. If you are unsure if your vehicle requires them, we recommend adding them.';
  var ICON_WARN = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path fill="currentColor" d="M12 2 1 21h22L12 2zm1 15h-2v-2h2v2zm0-4h-2V9h2v4z"/></svg>';
  var ICON_FIT = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>';

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function fmt(cents) { return '$' + (cents / 100).toFixed(2); }
  function hasResistors(names) { return (names || []).some(function (n) { return /^resistors?$/i.test(String(n && n.name || n).trim()); }); }
  function optNames(o) { return (o || []).map(function (n) { return String(n && n.name || n).trim(); }); }
  function isGift(o) { return optNames(o).some(function (n) { return /^denominations?$/i.test(n); }); }
  function needsPicker(x) { return !!x && (x.variants || []).length > 1 && !x.gift_card && !isGift(x.options); }
  function imgUrl(src, w) {
    var img = String(src || '');
    if (!img) return '';
    if (img.indexOf('//') === 0) img = 'https:' + img;
    img = img.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---- Shopper's vehicle year (from the saved Year / Make / Model search) ---- */
  function vehicleYear() {
    try {
      var v = window.__cdxFit && window.__cdxFit.vehicle && window.__cdxFit.vehicle();
      var y = v ? parseInt(v.year, 10) : NaN;
      return isNaN(y) ? null : y;
    } catch (e) { return null; }
  }
  function yearRange(title) {
    var m = String(title || '').match(/((?:19|20)\d{2})\s*-\s*((?:19|20)\d{2})/);
    return m ? [parseInt(m[1], 10), parseInt(m[2], 10)] : null;
  }
  function fitsYear(title, y) {
    var r = yearRange(title);
    return !!(r && y && y >= r[0] && y <= r[1]);
  }
  /* The one in-stock version that fits the shopper's year, if exactly one does */
  function autoPick(variants) {
    var y = vehicleYear();
    if (!y) return null;
    var f = (variants || []).filter(function (v) { return v.available && fitsYear(v.title, y); });
    return f.length === 1 ? f[0].id : null;
  }

  /* ---- The pop-up (one for the whole page) ---- */
  var modal = null, cur = null, pick = null;
  function open(p, opener, opts) {
    opts = opts || {};
    cur = { p: p, opener: opener, opts: opts };
    pick = opts.pick || null;
    var y = vehicleYear();
    var rows = p.variants.map(function (v) {
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      var fits = fitsYear(v.title, y);
      return '<button type="button" class="cdxmv-opt" role="radio" aria-checked="false" data-vid="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
        '<span class="cdxmv-opt-dot" aria-hidden="true"></span>' +
        '<span class="cdxmv-opt-text"><span class="cdxmv-opt-name">' + esc(v.title) + '</span>' +
          (fits ? '<span class="cdxmv-opt-tag">' + ICON_FIT + ' Fits your ' + esc(y) + '</span>' : '') + '</span>' +
        '<span class="cdxmv-opt-price">' + (v.available ? fmt(v.price) + (sale ? '<s>' + fmt(v.compare_at_price) + '</s>' : '') : 'Sold out') + '</span>' +
      '</button>';
    }).join('');
    var showWarn = p.variants.some(function (v) { return /resistor/i.test(v.title); });
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'cdxmv-modal';
      modal.addEventListener('click', onClick);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      document.body.appendChild(modal);
    }
    var img = imgUrl(p.image, 300);
    modal.innerHTML = '<div class="cdxmv-modal-bg" data-cdxres-close></div>' +
      '<div class="cdxmv-sheet" role="dialog" aria-modal="true" aria-label="Choose an option for ' + esc(p.title) + '">' +
        '<button type="button" class="cdxmv-x" data-cdxres-close aria-label="Close">&times;</button>' +
        '<div class="cdxmv-sheet-top">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') +
          '<div><h3 class="cdxmv-sheet-title">' + esc(opts.label || p.title) + '</h3>' +
          (opts.label ? '<p class="cdxmv-sheet-sub">' + esc(p.title) + '</p>' : '') + '</div></div>' +
        '<p class="cdxmv-opt-label">Choose an option</p>' +
        '<div class="cdxmv-opts" role="radiogroup">' + rows + '</div>' +
        (showWarn ? '<div class="cdxmv-note" role="note">' + ICON_WARN + '<p>' + esc(WARN) + '</p></div>' : '') +
        '<button type="button" class="cdxpf-add cdxmv-sheet-add" data-cdxres-add>Add to cart</button>' +
        (p.url ? '<a class="cdxmv-sheet-link" href="' + esc(p.url) + '">View full details</a>' : '') +
      '</div>';
    sync();
    modal.classList.add('is-open');
    document.documentElement.classList.add('cdxmv-lock');
    var first = modal.querySelector('.cdxmv-opt[aria-checked="true"]') || modal.querySelector('.cdxmv-opt:not([disabled])');
    if (first) { try { first.focus({ preventScroll: true }); } catch (err) {} }
  }
  function close() {
    if (!modal || !modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('cdxmv-lock');
    if (cur && cur.opener && document.contains(cur.opener)) { try { cur.opener.focus({ preventScroll: true }); } catch (err) {} }
  }
  function sync() {
    Array.prototype.forEach.call(modal.querySelectorAll('.cdxmv-opt'), function (b) {
      b.setAttribute('aria-checked', String(String(pick) === b.getAttribute('data-vid')));
    });
    var add = modal.querySelector('[data-cdxres-add]');
    var v = cur.p.variants.filter(function (x) { return x.id === pick; })[0];
    add.disabled = !v;
    add.textContent = v ? 'Add to cart – ' + fmt(v.price) : 'Choose an option above';
  }
  function onClick(e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    if (t.closest('[data-cdxres-close]')) { close(); return; }
    var o = t.closest('.cdxmv-opt');
    if (o && !o.disabled) { pick = parseInt(o.getAttribute('data-vid'), 10); sync(); return; }
    var add = t.closest('[data-cdxres-add]');
    if (add && !add.disabled && pick) addToCart(add, pick);
  }
  function addToCart(add, variantId) {
    var opener = cur && cur.opener;
    var opts = (cur && cur.opts) || {};
    add.disabled = true;
    add.textContent = 'Adding...';
    var drawer = document.querySelector('cart-drawer');
    var body = { id: variantId, quantity: 1 };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (res) {
        close();
        if (opts.onAdded) { try { opts.onAdded(); } catch (e) {} }
        else if (opener) { opener.textContent = 'Added'; opener.classList.add('cdxres-added'); }
        if (drawer && drawer.renderContents && res.sections) { drawer.renderContents(res); }
        else { window.location.href = '/cart'; }
      })
      .catch(function () { sync(); add.textContent = 'Could not add – try again'; });
  }
  window.cdxOpenOptions = open;

  /* ---- Product page ---- */
  function initProductPage() {
    var select = document.querySelector('.info-area > variant-selects select[name^="options["]');
    if (!select || /^options\[denominations?\]$/i.test(select.name)) return;   // gift card: keep theme form
    var area = select.closest('.info-area');
    var picker = select.closest('variant-selects');
    var form = area.querySelector('product-form');
    var dataEl = picker && picker.querySelector('script[type="application/json"]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent) || []; } catch (e) { variants = []; }
    if (variants.length < 2 || !form || area.querySelector('.cdxres-choose')) return;
    var h1 = area.querySelector('.title-area h1');
    var imgEl = document.querySelector('.product-media img');
    var p = {
      title: h1 ? h1.textContent.trim() : document.title,
      image: imgEl ? (imgEl.getAttribute('src') || '') : '',
      variants: variants.map(function (v) { return { id: v.id, title: v.title, price: v.price, compare_at_price: v.compare_at_price, available: v.available }; })
    };
    var any = p.variants.some(function (v) { return v.available; });
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'btn black-back white cdxres-choose';
    btn.textContent = any ? 'Add to cart' : 'Sold out';
    btn.disabled = !any;
    btn.addEventListener('click', function () { open(p, btn, { pick: autoPick(p.variants) }); });
    form.parentNode.insertBefore(btn, form);
  }

  /* ---- Product cards (collection pages, grids) ---- */
  var cardData = {};   // handle -> product (live feed), or false when there is nothing to choose
  function cardHandle(btn) {
    var card = btn.closest('[data-product-card], .bd-product-card');
    var a = card && card.querySelector('a[href*="/products/"]');
    var m = a && a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]).toLowerCase() : null;
  }
  function cardButtons() {
    return Array.prototype.filter.call(document.querySelectorAll('.bd-product-card button[data-toggle-target^="variant"], [data-product-card] button[data-toggle-target^="variant"]'), function (b) { return !!cardHandle(b); });
  }
  function fromFeed(x) {
    return {
      title: x.title, image: x.featured_image, url: '/products/' + x.handle,
      variants: (x.variants || []).map(function (v) { return { id: v.id, title: v.title, price: v.price, compare_at_price: v.compare_at_price, available: v.available }; })
    };
  }
  var loading = null;
  function loadCards() {
    var want = [];
    cardButtons().forEach(function (b) { var h = cardHandle(b); if (!(h in cardData) && want.indexOf(h) === -1) want.push(h); });
    if (!want.length) return Promise.resolve();
    want.forEach(function (h) { cardData[h] = null; }); // null = loading
    var parts = [];
    for (var i = 0; i < want.length; i += 20) parts.push(want.slice(i, i + 20));
    loading = Promise.all(parts.map(function (list) {
      return fetch('/search?view=cdxpf&q=' + encodeURIComponent(list.map(function (h) { return 'p.' + h; }).join(',')))
        .then(function (r) { return r.ok ? r.text() : '{"products":[]}'; })
        .then(function (t) { return JSON.parse(t).products || []; })
        .catch(function () { return []; });
    })).then(function (lists) {
      [].concat.apply([], lists).forEach(function (x) {
        cardData[String(x.handle).toLowerCase()] = needsPicker(x) ? fromFeed(x) : false;
      });
      want.forEach(function (h) { if (cardData[h] === null) cardData[h] = false; });
    });
    return loading;
  }
  /* Capture phase, so the theme's inline dropdown never opens for these products */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('.bd-product-card button[data-toggle-target^="variant"], [data-product-card] button[data-toggle-target^="variant"]');
    if (!b) return;
    var h = cardHandle(b);
    if (!h) return;
    var d = cardData[h];
    if (d === false) return;           // nothing to choose / gift card: old behaviour
    e.preventDefault();
    e.stopImmediatePropagation();
    if (d) { open(d, b, { pick: autoPick(d.variants) }); return; }
    /* Still loading (very fast clicker): wait, then decide */
    (d === null && loading ? loading : loadCards()).then(function () {
      var d2 = cardData[h];
      if (d2) open(d2, b, { pick: autoPick(d2.variants) });
      else { var card = b.closest('[data-product-card], .bd-product-card'); var a = card && card.querySelector('a[href*="/products/"]'); if (a) location.href = a.href; }
    });
  }, true);

  /* ---- Suggestion "Add" buttons: cart drawer (+ Add) and product page row ---- */
  var productCache = {};
  function productJson(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { if (!r.ok) throw new Error('product ' + r.status); return r.json(); })
        .catch(function (err) { delete productCache[handle]; throw err; });
    }
    return productCache[handle];
  }
  function suggestionHandle(btn) {
    var h = btn.getAttribute('data-cdxr-h');
    if (h) return h.toLowerCase();
    var card = btn.closest('.cdxpf-card');
    var a = card && card.querySelector('a[href*="/products/"]');
    var m = a && a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]).toLowerCase() : null;
  }
  function suggestionLabel(btn) {
    var card = btn.closest('.cdxr-card, .cdxpf-card');
    var n = card && card.querySelector('.cdxr-name, .cdxpf-name');
    return n ? n.textContent.trim() : '';
  }
  /* Window capture runs before the drawer / row's own document listeners */
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[data-cdxr-add], [data-cdxpf-add]');
    if (!btn || btn.closest('.cdxmv')) return;   // the vehicle page has its own picker
    if (btn.__cdxGo) { btn.__cdxGo = false; return; } // our own re-click: let it through
    var handle = suggestionHandle(btn);
    if (!handle || btn.disabled) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.__cdxBusy) return;
    btn.__cdxBusy = true;
    var isRec = btn.hasAttribute('data-cdxr-add');
    var attr = isRec ? 'data-cdxr-add' : 'data-cdxpf-add';
    productJson(handle).then(function (p) {
      btn.__cdxBusy = false;
      var y = vehicleYear();
      var avail = (p.variants || []).filter(function (v) { return v.available; });
      var fits = y ? avail.filter(function (v) { return fitsYear(v.title, y); }) : [];
      var allYear = avail.length > 0 && avail.every(function (v) { return !!yearRange(v.title); });
      var direct = null;
      if (avail.length === 1) direct = avail[0];
      else if (allYear && fits.length === 1) direct = fits[0];   // versions differ only by year
      if (direct) {
        btn.setAttribute(attr, direct.id);
        btn.__cdxGo = true;
        btn.click();
        return;
      }
      if (!avail.length) return;
      var prod = {
        title: p.title, image: p.featured_image, url: '/products/' + p.handle,
        variants: p.variants.map(function (v) { return { id: v.id, title: v.title, price: v.price, compare_at_price: v.compare_at_price, available: v.available }; })
      };
      open(prod, btn, {
        pick: fits.length === 1 ? fits[0].id : (avail.length === 1 ? avail[0].id : null),
        label: suggestionLabel(btn),
        onAdded: function () {
          if (!isRec && document.contains(btn)) { btn.textContent = 'Added'; btn.classList.add('is-added'); btn.disabled = true; }
        }
      });
    }).catch(function () {
      btn.__cdxBusy = false;
      location.href = '/products/' + handle;   // could not read the product: show its page
    });
  }, true);

  function init() {
    initProductPage();
    loadCards();
    /* Grids that load more products later (filters, infinite scroll) */
    var n = 0, iv = setInterval(function () { loadCards(); if (++n > 10) clearInterval(iv); }, 2000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
